(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-wishlist-section"] && !Shopify.designMode) return;
  try {
    
  
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
  
 function createWishListTplItem(ProductHandle, num_color) {
    console.log('from3',num_color)
    var wishListCotainer = $('[data-wishlist-container]');
    // console.log(currencyFormat)
   
    // jQuery.getJSON(window.Shopify.routes.root + '/products/'+ProductHandle+'.js', function(product) {
    jQuery.getJSON('/products/'+ProductHandle+'.js', function(product) {
        var productHTML = '';
        var displayTitle = (product.title || '').split(' - ')[0];
        // price_min = formatMoney(product.price_min, window.money_format);
        price_min = "$ " + String(Number(product.price_min/100).toFixed(2)) + " SGD";  
        compare_at_price_min = "$ " + String(Number(product.compare_at_price_min/100).toFixed(2)) + " SGD";  
      
        // productHTML += '<div class="grid-item" data-wishlist-added="wishlist-'+product.id+'">';
        productHTML += '<div class="" data-wishlist-added="wishlist-'+product.id+'">';
        productHTML += '<div class="inner product-item" data-product-id="product-'+product.handle+'">';
        productHTML += '<div class="column col-remove text-right"><a class="whislist-added" href="#" data-product-handle="'+ product.handle +'" data-product-type="'+ product.type +'" data-icon-wishlist data-id="'+ product.id +'"><svg class="closemnu" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 357 357" xml:space="preserve"><g><g><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></g></g></svg></a></div>';
        productHTML += '<div class="column col-img">';

        productHTML += `<div class="grid__item-image-wrapper grid__item-image-wrapper--7929804488896">
                         <div class="grid-product__image-mask">
                           <div class="grid__image-ratio grid__image-ratio--square">
                            <image-element data-aos="image-fade-in" data-aos-offset="150" class="aos-init aos-animate">
                              <img src="${product.featured_image}" alt="${product.featured_image.alt}" srcset="${product.featured_image}&amp;width=360 360w, ${product.featured_image}&amp;width=540 540w, ${product.featured_image}&amp;width=720 720w, ${product.featured_image}&amp;width=900 900w, ${product.featured_image}&amp;width=1080 1080w" width="1080" height="581.4" loading="lazy" class=" image-element" sizes="(min-width: 769px) 60vw, 100vw">
                            </image-element>
                            </div>
                           </div>
                        </div>`
        // productHTML += '<div class="product-image grid__item-image-wrapper">';
        // productHTML +='<a href="'+product.url+'" class="product-grid-image text-center" data-collections-related="/collections/all?view=related">';
        // if (product.featured_image) {
        //     productHTML += '<div class="product-single__media product-single__media--image">'
        //     // productHTML += '<div class="product-single__media--image-height" style="padding-top: 100.0%;"></div>'
        //     productHTML += '<figure class="lazy-image lazy-image--cover"><img src="'+product.featured_image+'"></figure>'
            
        //     productHTML += '<a href="'+product.url+'" class="product-single__media-link" rel="lightbox" data-zoom-wrapper="" data-image-width="800" data-image-height="800"><span class="visually-hidden">Open image lightbox</span></a></div>'
              
        //     // productHTML += '<img src="'+product.featured_image+'" alt="'+product.featured_image.alt+'">';
        // }
        // productHTML += '</a></div></div>';
        productHTML += '<div class="column col-prod">';
        productHTML += '<a class="product-title" href="'+product.url+'" title="'+displayTitle+'">'+displayTitle+'</a>';
        // productHTML += '<br/><span style="font-size:12px;">SKU: '+product.variants[0].sku+'</span>';
        // console.log("product1",product)
        // console.log("product",product.variants[0].sku)
        if (compare_at_price_min == price_min){
          productHTML += '<br/>'+price_min;
        }
        else{
          productHTML += '<br/>'+'<s class="product__price--compare">'+compare_at_price_min+'</s><span class="wishlist_price_new">'+price_min+'</span>';
        }
        productHTML += '<span class="wishlist_num_color">'+num_color+' Colors</span></div>';
        productHTML += '<div class="column col-options text-center">';
        productHTML += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + product.id +'" data-id="product-actions-'+product.id+'" enctype="multipart/form-data">';

        if (product.available) {
            if (product.variants.length == 1) {
                console.log("product link1")
                // productHTML += '<a class="btn btn--primary btn--solid btn--large" title="'+product.title+'" href="' + product.url +'">'+"Add To Cart"+'</a>';
                // here is add to cart
                productHTML += '<form method="post" action="/cart/add" id="AddToCartForm--template" class="product__form" enctype="multipart/form-data" data-product-form data-recipient-errors="false">'
                productHTML += '<input type="hidden" name="id" value="'+ product.variants[0].id +'" />'
                productHTML += '<input type="hidden" id="quantity" name="quantity" value="1"/>'
                productHTML += '<div class="product__submit__buttons">'
                productHTML += '<div class="product__submit__item aos-init aos-animate" data-aos="hero" data-aos-anchor="#FeaturedProduct--template--14762754441280__main" data-aos-order="1">'
                productHTML += '<input type="submit" value="Add to cart" class="product-form__add-button button button--primary button--full" /></div></div></form>'

                // productHTML += '<form method="post" action="/cart/add" id="template--14784120225856__6bfea71a-7d74-4bb1-abc0-d5d89ff9707c-6824119107648" accept-charset="UTF-8" class="quick__form" enctype="multipart/form-data" data-product-form="" data-quickbuy-form=""><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="quantity" value="1"><input type="hidden" name="id" value="39935820955712"><button type="submit" name="add" class="btn--quick rounded" data-add-to-cart="" data-atc-trigger="" tabindex="1"><span class="btn__inner"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-shopping-bag" viewBox="0 0 192 192"><path d="M156.6 162H35.4a6.075 6.075 0 0 1-6-5.325l-10.65-96A6 6 0 0 1 24.675 54h142.65a6.001 6.001 0 0 1 5.925 6.675l-10.65 96a6.076 6.076 0 0 1-6 5.325v0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M66 78V54a30 30 0 1 1 60 0v24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><circle class="cart-indicator" cx="96" cy="108" r="15"></circle></svg><span class="btn__text">Quick Buy</span><span class="btn__loader"><svg height="18" width="18" class="svg-loader"><circle r="7" cx="9" cy="9"></circle><circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle></svg></span></span></button><div class="product-grid-item__error" role="alert" data-cart-errors-container=""></div><input type="hidden" name="product-id" value="6824119107648"><input type="hidden" name="section-id" value="template--14784120225856__6bfea71a-7d74-4bb1-abc0-d5d89ff9707c"></form>'
            }
            if (product.variants.length > 1){
                productHTML += '<a class="product-form__add-button button button--primary button--full" title="'+displayTitle+'" href="' + product.url +'">'+"View Product"+'</a>';
                // productHTML += '<a class="btn" title="'+product.title+'" href="' + product.url +'">'+window.inventory_text.select_options+'</a>';
            }
        } else {
            productHTML += '<button class="product-form__add-button button button--ternary button--full" type="submit" disabled="disabled">'+"Unavailable"+'</button>';
            // productHTML += '<button class="btn add-to-cart-btn" type="submit" disabled="disabled">'+window.inventory_text.unavailable+'</button>';
        }
        
      
        productHTML += '</form></div>';
        productHTML += '</div></div>';

        // console.log('wishListCotainer',wishListCotainer)
        // console.log('productHTML',productHTML)
        // console.log('product',ProductHandle)
      
        wishListCotainer.append(productHTML);
        // var regex = /(<([^>]+)>)/ig;
        // var href = $('.wrapper-wishlist a.share').attr("href");
        // // href += encodeURIComponent( product.title + '\nPrice: ' + price_min.replace(regex, "") + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url +'\n\n');
        // href += encodeURIComponent( product.title + '\nPrice: ' + price_min + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url +'\n\n');
        
        // $('.wrapper-wishlist a.share').attr("href", href );
       
    });
}

  
  function doAddOrRemoveWishlish() {
    var iconWishListsSlt = '[data-icon-wishlist]';

    $(document).off('click.addOrRemoveWishlist', iconWishListsSlt).on('click.addOrRemoveWishlist', iconWishListsSlt, function(e) {
        e.preventDefault();

        var self = $(this),
        productId = self.data('id'),
        ProductHandle = self.data('product-handle'),
        wishListsArr = localStorage.getItem('shopify-wishlist').split(",")
        // console.log("before",localStorage.getItem('shopify-wishlist'))
        idxArr = wishListsArr.indexOf(ProductHandle);

        if(!self.hasClass('whislist-added')) {
            self.addClass('whislist-added');
            // if($('.style_product_grid_3').length) {
            //     // self.find('.wishlist-text').text(window.inventory_text.remove_wishlist_1);
            //     self.find('.wishlist-text').text(window.inventory_text.remove_wishlist_1);
            // } else {
            //     // self.find('.wishlist-text').text(window.inventory_text.remove_wishlist);
            //   self.find('.wishlist-text').text(window.inventory_text.remove_wishlist);
            // }

            if($('[data-wishlist-container]').length) {
                createWishListTplItem(ProductHandle);
            };

            wishListsArr.push(ProductHandle);
            localStorage.setItem('shopify-wishlist', JSON.stringify(wishListsArr));
        } else {
            self.removeClass('whislist-added');
            // if($('.style_product_grid_3').length) {
            //     self.find('.wishlist-text').text(window.inventory_text.add_wishlist_1);
            // } else {
            //     self.find('.wishlist-text').text(window.inventory_text.add_wishlist);
            // }
            
            if($('[data-wishlist-added="wishlist-'+productId+'"]').length) {
                $('[data-wishlist-added="wishlist-'+productId+'"]').remove();
            }

            wishListsArr.splice(idxArr, 1);
            // console.log("wishListsArr",wishListsArr)
            // console.log("JSON.stringify(wishListsArr)",JSON.stringify(wishListsArr).replace(/"/g, '').replace(/'/g, '').replace("[",'').replace("]",''))
            localStorage.setItem('shopify-wishlist',JSON.stringify(wishListsArr).replace(/"/g, '').replace(/'/g, '').replace("[",'').replace("]",''));
            // console.log("after",localStorage.getItem('shopify-wishlist'))
          
            if($('[data-wishlist-container]').length) {
                // initWishListPagging();
            };
        };

        // ella.setAddedForWishlistIcon(ProductHandle);
    });
}

  doAddOrRemoveWishlish();
  
  function initWishListPagging() {
    var data = localStorage.getItem('shopify-wishlist').split(",")
    // var data = JSON.parse(localStorage.getItem('items'));
    // console.log('data',data)
    var wlpaggingContainer = $('#wishlist-paginate');
    // var paggingTpl = '<li class="text disabled prev"><a href="#" title="'+window.inventory_text.previous+'"><i class="fa fa-angle-left" aria-hidden="true"></i><span>'+window.inventory_text.previous+'</span></a></li>';
    var paggingTpl = '<li class="text disabled prev"><a href="#" title="prev"><i class="fa fa-angle-left" aria-hidden="true"></i><span>prev</span></a></li>';
    var wishListCotainer = $('[data-wishlist-container]');

    wlpaggingContainer.children().remove();

    var totalPages = Math.ceil(data.length / 3);

    if (totalPages <= 1) {
        wishListCotainer.children().show();
        return;
    }

    for (var i = 0; i < totalPages; i++) {
        var pageNum = i + 1;
        if (i === 0) paggingTpl += '<li class="active"><a data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
        else paggingTpl += '<li><a data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
    }

    paggingTpl += '<li class="text next"><a href="#" title="next"><span>next</span><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>';

    wlpaggingContainer.append(paggingTpl);

    wishListCotainer.children().each(function(idx, elm) {
        if (idx >= 0 && idx < 3) {
            $(elm).show();
        }
        else {
            $(elm).hide();
        }
    });

    wlpaggingContainer.off('click.wl-pagging').on('click.wl-pagging', 'li a', function(e) {
        e.preventDefault();

        var isPrev = $(this).parent().hasClass('prev');
        var isNext = $(this).parent().hasClass('next');
        var pageNumber = $(this).data('page');

        if (isPrev) {
            var curPage = parseInt($(this).parent().siblings('.active').children().data('page'));
            pageNumber = curPage - 1;
        }

        if (isNext) {
            var curPage = parseInt($(this).parent().siblings('.active').children().data('page'));
            pageNumber = curPage + 1;
        }

        wishListCotainer.children().each(function(idx, elm) {
            if (idx >= (pageNumber - 1) * 3 && idx < pageNumber * 3) {
                $(elm).show();
            }
            else {
                $(elm).hide();
            }
        });

        if (pageNumber === 1) {
            wlpaggingContainer.find('.prev').addClass('disabled');
            wlpaggingContainer.find('.next').removeClass('disabled');
        }
        else if (pageNumber === totalPages) {
            wlpaggingContainer.find('.next').addClass('disabled');
            wlpaggingContainer.find('.prev').removeClass('disabled');
        }
        else {
            wlpaggingContainer.find('.prev').removeClass('disabled');
            wlpaggingContainer.find('.next').removeClass('disabled');
        }

        $(this).parent().siblings('.active').removeClass('active');
        wlpaggingContainer.find('[data-page="' + pageNumber + '"]').parent().addClass('active');

    });
}
  
  function initWishLists() {
    if (typeof(Storage) !== 'undefined') {
        // console.log('HI')
        // console.log(localStorage.getItem('shopify-wishlist').split(","))
        var data = localStorage.getItem('shopify-wishlist').split(",")
        // var data = JSON.parse("["+localStorage.getItem('shopify-wishlist')+"]");
        // console.log("data",typeof(data))
        if (data.length <= 0) {
            return;
        }
        var product_types = []
        data.forEach(function(item) {
          product_types.push(item.split('_')[1])
        })
        var type_query = product_types.join(' OR ')
        // console.log('product_types 4',type_query)
      
        // console.log('get graphql')
        $j.ajax({
          url: 'https://teva-singapore.myshopify.com/api/2023-07/graphql.json',
          method: 'post',
          headers: {
            'X-Shopify-Storefront-Access-Token': '4e188e7592489b87389206c6170f914f',
            'Content-Type': 'application/json',
          },
          data: JSON.stringify({
            query: `
              {
                products(first: 50,query: "product_type:${type_query}" ) {
                  edges {
                    node {
                      id
                      title
                      handle
                      productType
                    }
                  }
                }
              }
    
            `,
          }),
          success: function(response) {
            // console.log("wishlist",typeof(response),response);
            // console.log('success data',data)

            const colour_products = response.data.products.edges
            .map(({ node }) => ({
              id: node.id,
              title: node.title,
              handle: node.handle,
              product_type: node.productType
            }));

            // console.log('colour_products 1',colour_products)
            data.forEach(function(item) {
              var item_type = item.split('_')[1]
              // console.log('item_type 1',item_type)
              var same_type_products = colour_products.filter(function (el) {
                if ( el.product_type != item_type ) {
                  return false; // skip
                }
                return true;
              });
              // console.log("same_type_products",same_type_products.length)
              createWishListTplItem(item.split('_')[0],same_type_products.length);
            });
          }
        });
        
        
        // initialize flickity
        console.log('initialize flickity 2')
        // var flkty = new Flickity('.wishlist-content', {
        // // $j('.wishlist-content').flickity({
        //   pageDots: false,
        //   groupCells : true
        // });

        // var flkty = new Flickity( '.wishlist-content', {
        //   cellAlign: 'left',
        //   contain: true
        // });

    } else {
        alert('Sorry! No web storage support..');
    }
}

  initWishLists()

  } catch(e) { console.error(e); }
})();
})();
